export default {
  HANDLE_SUCCESS_GET_SOURCES: 'handleSuccessGetSources',
  HANDLE_CREATE_SOURCE_IN_PROGRESS: 'handleCreateSourceInProgress',
};



// WEBPACK FOOTER //
// ./src/app/main/sources/constants/action-types.js